module.exports = __webpack_public_path__ + "img/area-8-1.283a586.jpg";